const project = {
    normalText: "Mi",
    strongText: 'Proyecto',
    content : [
        {
            "id": 0,
            "name": 'Telegram Bot Info Covid-19 Indonesia',
            "category": "python",
            "aboutProject": `Di dalam project ini saya membuat sebuah telegram bot yang berfungsi untuk memberikan informasi tentang perkembangan covid-19 di indonesia seperti jumlah pasien positif, jumlah pasien sembuh, jumlah pasien dirawat beserta jumlah pasien yang meninggal.
            
            Project ini dibuat menggunakan bahasa pemprograman Python beserta dengan API Telegram Bot.`,
            "tags": ["Python", "Telegram Bot API"],
            "button": {
                "Demo": 'https://t.me/Covid_SembilanBelas_Info_Bot',
                "Github": 'https://github.com/tisoga/telegram_bot_covid_19',
                "Private": false,
                "Mobile": false,
                "Web": false,
                "REST": false,
                "Screenshot": false,
            }
        },
        {
            "id": 1,
            "name": 'Web Scraping untuk Jurnal atau Paper di Google Scholar',
            "category": "python",
            "aboutProject": `Project ini berfungsi untuk mengambil informasi tentang jurnal atau paper dari Profile penulis di web google scholar, informasi yang diambil seperti : Judul Jurnal, Tahun Terbit Jurnal, Penulis Jurnal dan link menuju ke jurnal tersebut. Informasi yang telah diambil tersebut lalu akan disimpan dalam sebuah file .CSV.
            Project ini dibuat menggunakan bahasa pemprograman python beserta dengan menggunakan salah satu library web scraping yaitu Beautifulsoup.`,
            "tags": ["Python", "Web Scraping", "Beautifulsoup"],
            "button": {
                "Demo": false,
                "Github": 'https://github.com/tisoga/get_data_journal_google_schoolar',
                "Private": false,
                "Mobile": false,
                "Web": false,
                "REST": false,
                "Screenshot": false,
            }
        },
        {
            "id": 2,
            "name": 'Web Scraping untuk Semua Informasi dan Gambar Pokemon',
            "category": "python",
            "aboutProject": `Project ini berfungsi untuk mengambil informasi dan menyimpan gambar pokemon dari generasi 1 hingga generasi 8. Informasi yang diambil adalah Nama Pokemon dan tipe pokemon. Informasi yang telah diambil tersebut lalu akan disimpan dalam sebuah file .CSV, untuk gambar akan disimpan di direktori yang sama dengan file ini.
            Project ini dibuat menggunakan bahasa pemprograman python beserta dengan menggunakan salah satu library web scraping yaitu Beautifulsoup.`,
            "tags": ["Python", "Web Scraping", "Beautifulsoup"],
            "button": {
                "Demo": false,
                "Github": 'https://github.com/tisoga/get_pokemon_data',
                "Private": false,
                "Mobile": false,
                "Web": false,
                "REST": false,
                "Screenshot": false,
            }
        },
        {
            "id": 3,
            "name": 'Portofolio Website Ini',
            "category": "web",
            "aboutProject": `Web ini bertujuan untuk menunjukan beberapa project yang pernah saya kerjakan.
            
            Web ini dibuat menggunakan React.JS dengan menggunakan Framework CSS Tailwind.`,
            "tags": ["HTML + CSS", "ReactJS", "Tailwind"],
            "button": {
                "Demo": false,
                "Github": 'https://github.com/tisoga/portofolio',
                "Private": false,
                "Mobile": false,
                "Web": false,
                "REST": false,
                "Screenshot": false,
            }
        },
        {
            "id": 4,
            "name": 'Aplikasi Penerimaan Peserta Didik Baru Tingkat SMA (Web)',
            "category": "web",
            "aboutProject": `Di dalam project ini saya membuat sebuah sistem aplikasi berbasis web untuk membantu pihak sekolah dalam melaksanakan kegiatan Penerimaan Peserta Didik Baru (PPDB) berserta membangun sebuah REST API yang nantinya akan membantu membuat aplikasi berbasis web terhubung dengan aplikasi berbasis mobile. Di dalam aplikasi ini nantinya calon siswa juga dapat memilih jalur pendaftaran yang akan diikuti seperti jalur zonasi, jalur afirmasi, jalur perpindahan orang tua, dan jalur prestasi..
            
            Project ini dibuat menggunakan bahasa pemprograman Python beserta dengan Web Framework Django, REST API dibangun dengan menggunakan toolkit django rest framework, untuk Framework CSS menggunakan Bootstrap dan menggunakan MySQL sebagai database.`,
            "tags": ["HTML + CSS", "Django", "Django Rest API", "Bootstrap", "MySQL"],
            "button": {
                "Demo": 'http://ryan-retired.site/ppdb',
                "Github": 'https://github.com/tisoga/project_skripsi_web_pendaftaran',
                "Private": false,
                "Mobile": false,
                "Web": false,
                "REST": false,
                "Screenshot": false,
            }
        },
        {
            "id": 5,
            "name": 'Aplikasi Pencatatan Kegiatan Karyawan PT PLN Bagian Sub Bidang Pendayagunaan Aset (Web)',
            "category": "web",
            "aboutProject": `Aplikasi ini bertujuan untuk mencatat kegiatan karyawan PT PLN bagian sub bidang pendayagunaan aset, sehingga seluruh kronologi kasus yang sedang dikerjakan dapat di ketahui oleh seluruh karyawan. Aplikasi ini juga memberikan notifikasi jika terdapat kasus baru atau kasus hampir mencapai deadline kepada karyawan yang telah terdaftar melalui telegram.
                
            Aplikasi ini dibuat menggunakan bahasa pemprograman Python beserta dengan Web Framework Django, untuk Framework CSS menggunakan Bootstrap dan menggunakan MySQL sebagai database. Untuk Notifikasi Telegram dikirmkan dengan memanfaatkan Telegram BOT API.`,
            "tags": ["HTML + CSS", "Django", "Bootstrap", "MySQL", "Telegram BOT"],
            "button": {
                "Demo": false,
                "Github": false,
                "Private": true,
                "Mobile": false,
                "Web": false,
                "REST": false,
                "Screenshot": 'https://postimg.cc/gallery/9hsxJpM',
            }
        },
        {
            "id": 6,
            "name": 'Aplikasi Penerimaan Peserta Didik Baru Tingkat SMA (Mobile)',
            "category": "mobile",
            "aboutProject": `Di dalam project ini saya membuat sebuah aplikasi berbasis mobile untuk membantu pihak sekolah dalam melaksanakan kegiatan Penerimaan Peserta Didik Baru (PPDB) dengan mengambil data dari REST API aplikasi berbasis web yang telah dibuat. Di dalam aplikasi ini nantinya calon siswa juga dapat memilih jalur pendaftaran yang akan diikuti seperti jalur zonasi, jalur afirmasi, jalur perpindahan orang tua, dan jalur prestasi.
            
            Aplikasi ini dibuat menggunakan React Native dan menggunakan MySQL sebagai database.`,
            "tags": ["React Native", "Rest API", "MySQL"],
            "button": {
                "Demo": 'https://bit.ly/ppdb-online-',
                "Github": 'https://github.com/tisoga/PPDB_Online',
                "Private": false,
                "Mobile": false,
                "Web": false,
                "REST": false,
                "Screenshot": 'https://postimg.cc/gallery/5J5Pq99',
            }
        },
        {
            "id": 7,
            "name": 'Aplikasi Pencatatan Kegiatan Karyawan PT PLN Bagian Sub Bidang Pendayagunaan Aset (Mobile)',
            "category": "mobile",
            "aboutProject": `Aplikasi ini bertujuan untuk mencatat kegiatan karyawan PT PLN bagian sub bidang pendayagunaan aset, sehingga seluruh kronologi kasus yang sedang dikerjakan dapat di ketahui oleh seluruh karyawan. Dengan menggunakan Aplikasi Mobile ini Karyawan dapat login tanpa memasukan user id dan password asalkan IMEI Devicenya telah di daftarkan.
                
            Aplikasi ini dibuat menggunakan Android Stduio Web View dengan memanfaatkan tampilkan Aplikasi Web yang responsif.`,
            "tags": ["Android Studio", "Web View"],
            "button": {
                "Demo": false,
                "Github": false,
                "Private": true,
                "Mobile": false,
                "Web": false,
                "REST": false,
                "Screenshot": 'https://postimg.cc/gallery/9hsxJpM',
            }
        },
    ]
}

export default project